import React from 'react';
import { Colors, Flex } from '@banhala/ui-kit';
import Animated, {
  interpolate,
  type SharedValue,
  useAnimatedStyle,
} from 'react-native-reanimated';

const DOT_SIZE = 7;
const GAP_DOT = 8;

export const PaginationDots: React.FC<{
  value: number;
  scrollX: SharedValue<number>;
  maxCount: number;
}> = props => {
  const animatedStyle = useAnimatedStyle(() => ({
    ///opacity={props.value === i ? 1 : 0.4}
    width: DOT_SIZE,
    height: DOT_SIZE,
    borderRadius: DOT_SIZE * 0.5,
    opacity: 1,
    backgroundColor: Colors.content_always_white,
    position: 'absolute',
    transform: [
      {
        translateX: interpolate(
          props.scrollX.value,
          Array.from({ length: props.maxCount }, (_, index) => index),
          Array.from(
            { length: props.maxCount },
            (_, index) => index * (DOT_SIZE + GAP_DOT),
          ),
        ),
      },
    ],
  }));

  return (
    <Flex.Row gap={GAP_DOT} position={'relative'}>
      {Array.from({ length: props.maxCount }).map((_, i) => (
        <Flex
          key={`Pagination_${i}`}
          backgroundColor={'bg_always_white'}
          opacity={0.4}
          width={DOT_SIZE}
          height={DOT_SIZE}
          borderRadius={DOT_SIZE * 0.5}
        ></Flex>
      ))}
      <Animated.View style={animatedStyle}></Animated.View>
    </Flex.Row>
  );
};
